<template>
  <div class="ny-pageV2">
    <div class="inner">
      <NavView />
      <NavMarkView />
      <Purchase :isShowToast="ShowToast" :bookId="represe.ID" :bookName="represe.EBOOKNAME"
        @hideToast="hidePurchaseToast"></Purchase>
      <div class="author-page">
        <div class="left">
          <LeftMenu :active="isActive" :data="navData" @columnClick="columnClick" v-if="navData.length > 0" />
        </div>
        <div class="right">
          <template v-if="CLASSICAL.TYPE == 1">
            <div class="author-box">
              <swiper class="author-list" v-if="authorData.length > 0" :options="swiperOption"
                :not-next-tick="notNextTick" ref="authorList">
                <!-- slides -->
                <swiper-slide class="item" :class="currentAuthor === item.ID ? 'is-current' : ''"
                  v-for="item of authorData" :key="item.Id">
                  <a @click="handleAuthor(item.ID)" :title="item.NAME">
                    <div class="s-img">
                      <img :src="$bti.ServerUrl + item.COVER">
                    </div>
                    <div class="info">
                      <div class="time">{{ item.WINNING_INFO }}</div>
                      <div class="author">{{ item.NAME }}</div>
                    </div>
                  </a>
                </swiper-slide>
              </swiper>
              <!-- Optional controls -->
              <div class="swiper-button-prev authorPrev">
                <i class="el-icon-arrow-left"></i>
              </div>
              <div class="swiper-button-next authorNext">
                <i class="el-icon-arrow-right"></i>
              </div>
            </div>
            <div class="author-bottom">
              <div class="info-left">
                <div class="info-head">
                  <div class="title">{{ info.WINNING_INFO }}获奖者：{{ info.NAME }}</div>
                  <div class="des">{{ info.WINNING_DERI }}</div>
                </div>
                <div class="info-sec">
                  <div class="sec-ti">作者简介</div>
                  <div class="sec-con">
                    <div class="sec-content">
                      {{ info.AUTHORINFO }}
                    </div>
                    <div class="sec-img">
                      <img :src="$bti.ServerUrl + info.AUTHORINFO_COVER" :title="info.NAME" :alt="info.NAME">
                    </div>
                  </div>
                </div>
                <div class="info-sec">
                  <div class="sec-ti">代表作品</div>
                  <div class="sec-con">
                    <div class="bd-item">
                      <div class="s-img" @click="read(represe)">
                        <img :src="represe.COVER ? represe.COVER : '/static/img/default_image.jpg'" :alt="represe.EBOOKNAME"
                          :title="represe.EBOOKNAME" onerror="this.src='/static/img/default_image.jpg'">
                        <span class="ou-lf-tag"
                          v-if="represe.SOURCEOPENTYPE === '01' || represe.SOURCEOPENTYPE === '02'">{{
                            $com.getBookOpenText(represe.SOURCEOPENTYPE) }}</span>
                      </div>
                      <div class="s-info">
                        <div class="s-ti" :title="represe.EBOOKNAME" @click="read(represe)">{{ represe.EBOOKNAME }}</div>
                        <div class="s-para" @click="read(represe)">
                          <div class="para-item">{{ represe.AUTHOR }}<span v-if="represe.PUBLISHTIME">|</span></div>
                          <div class="para-item">{{ represe.PUBLISHTIME }}<span v-if="represe.PUBLISHER">|</span></div>
                          <div class="para-item">{{ represe.PUBLISHER }}</div>
                        </div>
                        <!-- <div class="s-rate">
                        <el-rate v-model="represe.value" disabled show-score text-color="#ff9900"
                          score-template="{value}">
                        </el-rate>
                      </div> -->
                        <div class="s-dec" @click="read(represe)">{{ represe.INTRODUCTION }}</div>
                        <div class="s-btns">
                          <div class="item-btn" :class="represe.IsFollow ? 'btn-blue' : 'btn-default'"
                            @click="follow(represe)"><span class="icon iconfont icon-shoucang"></span>收藏</div>
                          <div class="item-btn" :class="represe.PURCHASEFLAG ? 'btn-red' : 'btn-default'"
                            @click="purchase(represe)" v-if="represe.FLAG"><span
                              class="icon iconfont icon-dianzan"></span>荐购</div>
                          <div class="item-btn" :class="represe.IsCollect ? 'btn-red' : 'btn-default'"
                            @click="addCollect(represe)" v-else><span class="icon iconfont icon-dianzan"></span>加入书架</div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="info-right">
                <div class="hot-box">
                  <div class="ri-arrow"></div>
                  <div class="h-head">{{ title }}<span class="T-type">{{ type }}</span></div>
                  <div class="h-body">
                    <div class="h-item" v-for="(item, index) of listData" :key="index">
                      <a :title="item.NAME" @click="read(item)">
                        <div class="s-img">
                          <img :src="item.COVER ? item.COVER : '/static/img/default_image.jpg'"
                            onerror="this.src='/static/img/default_image.jpg'">
                          <div class="ou-lf-tag" v-if="item.SOURCEOPENTYPE === '01' || item.SOURCEOPENTYPE === '02'">{{
                            $com.getBookOpenText(item.SOURCEOPENTYPE) }}</div>
                        </div>
                        <div class="s-ti">{{ item.NAME }}</div>
                      </a>
                    </div>
                  </div>
                  <div class="ou-pagination">
                    <el-pagination class="swiperBtns" layout="prev, next" @current-change="page.changePage"
                      :current-page="page.page" :page-size="page.rows" :total="total">
                    </el-pagination>
                  </div>
                  <!-- <swiper class="h-body" v-if="listData.length > 0" :options="rightOption" :not-next-tick="notNextTick2"
                 ref="rightList">
                 <swiper-slide class="h-item" v-for="(item,index) of listData" :key="index">
                   <a href="javascript:(0)">
                     <div class="s-img"><img :src="item.COVER" @click="read(item)" v-if="item.COVER"><img v-else src="/static/img/nodata.png"  @click="read(item)"></div>
                     <div class="s-ti">{{ item.EBOOKNAME }}</div>
                   </a>
                 </swiper-slide>
               </swiper>
               <div class="swiperBtns">
                 <div class="swiper-button-prev rightPrev">
                   <i class="el-icon-arrow-left"></i>
                 </div>
                 <div class="swiper-button-next rightNext">
                   <i class="el-icon-arrow-right"></i>
                 </div>
               </div> -->
                </div>
              </div>
            </div>
          </template>
          <template v-else>
            <div class="author-sec">
              <div class="huojiang-title">
                <img src="@/assets/jiangbei.png">
                {{ CLASSICAL.NAME }}
              </div>
              <div class="authorjx-info">
                {{ CLASSICAL.REMARK }}
              </div>
              <div class="list-box">
                <div class="item" v-for="item of listData1" :key="item.id">
                  <div class="s-img" @click="read1(item)">
                    <img :src="item.cover ? item.cover : '/static/img/default_image.jpg'" :title="item.title"
                      :alt="item.title" onerror="this.src='/static/img/default_image.jpg'">
                  </div>
                  <div class="s-info">
                    <div :title="item.title" class="name">{{ item.title }}</div>
                    <div class="para">{{ item.author }}</div>
                  </div>
                  <div class="s-btns">
                    <div class="item-btn" :class="item.isFollow ? 'btn-blue' : 'btn-default'" @click="follow1(item)">
                      <span class="icon iconfont icon-shoucang"></span>
                      {{ item.isFollow ? '移除' : '收藏' }}
                    </div>
                    <div class="item-btn" :class="item.isCollect ? 'btn-red' : 'btn-default'" @click="addCollect1(item)">
                      {{ item.isCollect ? '移除书架' : '加入书架' }}
                    </div>
                  </div>
                </div>
              </div>
              <PaginationView :page="page1.page" :size="page1.rows" :total="page1.total" @changePage="page1.changePage" />
            </div>
            <div class="author-sec">
              <div class="bl-title">历届获奖信息</div>
              <div class="ti-tab-list">
                <swiper class="year-list" v-if="yearData.length > 0" :options="yearOption" :not-next-tick="notNextTick3"
                  ref="yearList">
                  <!-- slides -->
                  <swiper-slide class="item" :class="currentYear === item ? 'is-current' : ''" v-for="item of yearData"
                    :key="item.id">
                    <div class="item-inner" @click="handleYear(item)"><span>{{ item }}</span></div>
                  </swiper-slide>
                </swiper>
                <!-- Optional controls -->
                <div class="swiper-button-prev yearPrev">
                  <i class="el-icon-arrow-left"></i>
                </div>
                <div class="swiper-button-next yearNext">
                  <i class="el-icon-arrow-right"></i>
                </div>
              </div>
              <div class="list-box">
                <div class="item" v-for="item of listData2" :key="item.id">
                  <div class="s-img" @click="read1(item)">
                    <img :src="item.cover ? item.cover : '/static/img/default_image.jpg'" :title="item.title"
                      :alt="item.title" onerror="this.src='/static/img/default_image.jpg'">
                  </div>
                  <div class="s-info">
                    <div :title="item.title" class="name">{{ item.title }}</div>
                    <div class="para">{{ item.author }}</div>
                  </div>
                  <div class="s-btns">
                    <div class="item-btn" :class="item.isFollow ? 'btn-blue' : 'btn-default'" @click="follow1(item)">
                      <span class="icon iconfont icon-shoucang"></span>
                      {{ item.isFollow ? '移除' : '收藏' }}
                    </div>
                    <div class="item-btn" :class="item.isCollect ? 'btn-red' : 'btn-default'" @click="addCollect1(item)">
                      {{ item.isCollect ? '移除书架' : '加入书架' }}
                    </div>
                  </div>
                </div>
              </div>
              <PaginationView :page="page2.page" :size="page2.rows" :total="page2.total" @changePage="page2.changePage" />
            </div>
          </template>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import NavView from "common/NavView";
import NavMarkView from "common/NavMarkView";
import Purchase from "common/Purchase";
import LeftMenu from "./components/LeftMenu";
import PaginationView from "common/PaginationView";
var vm = null;
export default {
  name: "Author",
  components: {
    NavView,
    NavMarkView,
    LeftMenu,
    Purchase,
    PaginationView,
  },
  data() {
    return {
      isActive: '',
      navData: [],
      total: 0,
      total1: 0,
      notNextTick: false,
      swiperOption: {
        mousewheelControl: false,
        observeParents: true,
        slidesPerView: 9,
        spaceBetween: 22,
        prevButton: '.authorPrev',
        nextButton: '.authorNext',
      },
      page: {
        order: "",
        sort: "desc",
        page: 1,
        rows: 6,
        data: [],
        total: 0,
        wheres: {},
        load: () => {
          this.page.wheres.ID = this.currentAuthor
          this.$bti.TeacherOtherEbook({ page: this.page.page, rows: this.page.rows, order: this.page.order, sort: "desc", wheres: this.page.wheres }).then((res) => {
            if (res.code != 1) {
              return;
            }
            this.listData = res.data.rows;
            this.total = res.data.total;
          });
        },
        changePage: (val) => {
          this.page.page = val;
          this.page.load();
        }
      },

      page1: {
        order: "",
        sort: "",
        page: 1,
        rows: 8,
        data: [],
        total: 0,
        wheres: {},
        load: () => {
          this.page1.wheres.ID = this.CLASSICAL.ID
          this.$bti.ClassIcalBook({ page: this.page1.page, rows: this.page1.rows, order: this.page1.order, sort: this.page1.sort, wheres: this.page1.wheres }).then((res) => {
            if (res.code != 1) {
              return;
            }
            this.listData1 = res.data.rows;
            this.page1.total = res.data.total;
          });
        },
        changePage: (val) => {
          this.page1.page = val;
          this.page1.load();
        }
      },

      page2: {
        order: "",
        sort: "",
        page: 1,
        rows: 8,
        data: [],
        total: 0,
        wheres: {},
        load: () => {
          this.page2.wheres.ID = this.CLASSICAL.ID
          this.page2.wheres.YEAR = this.currentYear;
          this.$bti.ClassIcalBookGroup({ page: this.page2.page, rows: this.page2.rows, order: this.page2.order, sort: this.page2.sort, wheres: this.page2.wheres }).then((res) => {
            if (res.code != 1) {
              return;
            }
            this.listData2 = res.data.rows;
            this.page2.total = res.data.total;
          });
        },
        changePage: (val) => {
          this.page2.page = val;
          this.page2.load();
        }
      },
      authorData: [],
      info: {},
      represe: {},
      ShowToast: false,
      currentAuthor: '',
      title: '作者其它作品 | 建议马上收藏',
      type: 'SAVE',
      listData: [],
      listData1: [],
      listData2: [],
      notNextTick2: false,
      rightOption: {
        mousewheelControl: false,
        observeParents: true,
        slidesPerView: 3,
        slidesPerColumn: 2,
        spaceBetween: 33,
        slidesPerGroup: 1,
        prevButton: '.rightPrev',
        nextButton: '.rightNext',
      },
      styleType: 1,
      demoDate: [
      ],
      demopage: {
        page: 1,
        rows: 10,
        total: 0,
        changePage: (val) => {
        },
      },
      yearData: [
      ],
      notNextTick3: false,
      CLASSICAL: '',
      yearOption: {
        mousewheelControl: false,
        observeParents: true,
        slidesPerView: 6,
        spaceBetween: 12,
        prevButton: '.yearPrev',
        nextButton: '.yearNext',
      },
      currentYear: '',
    }
  },
  computed: {
    swiper() {
      return this.$refs.authorList.swiper;
    }
  },
  created() {
    this.load();
  },
  methods: {
    handleYear(ID) {
      this.currentYear = ID;
      this.page2.page = 1;
      this.page2.load();
    },
    handleCollect(ID) {
      this.demoDate.map(item => {
        if (item.id == ID) {
          item.collect = !item.collect;
        }
      })
    },
    handleFollow(ID) {
      this.demoDate.map(item => {
        if (item.id == ID) {
          item.Follow = !item.Follow;
        }
      })
    },
    read(item) {
      if (item.WINTYPE === 1) {
        this.$message({ type: "error", message: "该书籍暂无阅读信息" });
        return;
      }
      this.$fun.openProductUrl(item.ID)
    },
    read1(item) {
      if (item.factoryId == null) {
        this.$message({ type: "error", message: "该书籍暂无阅读信息" });
        return;
      }
      this.$fun.openProductUrl(item.id)
    },
    load() {
      this.$bti.ClassIcalList().then((res) => {
        this.navData = res.data
        if (this.navData.length > 0) {
          this.isActive = this.navData[0].ID
          this.CLASSICAL = this.navData[0];
          this.teacherLoad(this.isActive);
        }
      })
    },
    teacherLoad(id) {
      this.$bti.FindTeacherById({ id: id }).then((res) => {
        this.authorData = res.data
        if (this.authorData.length > 0) {
          this.currentAuthor = this.authorData[0].ID
          this.info = this.authorData[0];
          this.handleAuthor(this.currentAuthor);
        } else {

        }
      })
    },
    purchase(item) {
      if (this.$com.openLogin()) {
        return;
      }
      this.$bti.ExistPurchase({ id: item.ID }).then((res) => {
        if (res.code != 1) {
          return this.$message({ type: "success", message: res.data });;
        }
        this.ShowToast = true;
      });
    },
    hidePurchaseToast(val) {
      if (val) {
        location.href = location.href;
      }
      this.ShowToast = false;
    },
    follow(item) {
      if (this.$com.openLogin()) {
        return;
      }
      this.$bti.SubmitCollect({ sourceId: item.ID, sourceType: 11 }).then((res) => {
        if (res.code != 1) {
          return;
        }
        this.$message({ type: res.code ? "success" : "error", message: res.data });
        item.IsFollow = !item.IsFollow;
      });
    },
    follow1(item) {
      if (this.$com.openLogin()) {
        return;
      }
      this.$bti.SubmitCollect({ sourceId: item.id, sourceType: 11 }).then((res) => {
        if (res.code != 1) {
          return;
        }
        this.$message({ type: res.code ? "success" : "error", message: res.data });
        item.isFollow = !item.isFollow;
        this.listData1.forEach(element => {
          if (element.id === item.id) {
            element.isFollow = item.isFollow;
          }
        });
        this.listData2.forEach(element => {
          if (element.id === item.id) {
            element.isFollow = item.isFollow;
          }
        });
      });
    },
    handleCollection() {
      this.represe.collection = this.represe.collection === 0 ? 1 : 0;
    },
    handlePurchase() {
      this.$message({ type: "error", message: "功能开发中……" });
    },
    columnClick(item) {
      this.isActive = item.ID;
      this.CLASSICAL = item;
      this.info = {};
      if (item.TYPE == 1) {
        this.teacherLoad(item.ID);
      } else {
        this.ClassIcalBookGroupYear();
        this.page1.page = 1
        this.page2.page = 1
        this.page1.load()
      }
    },
    ClassIcalBookGroupYear() {
      this.$bti.ClassIcalBookGroupYear({ id: this.CLASSICAL.ID }).then((res) => {
        this.yearData = res.data
        this.currentYear = this.yearData[0]
        this.page2.load();
      })
    },
    handleAuthor(id) {
      this.represe = {};
      this.currentAuthor = id;
      this.$bti.TeacherById({ id: id }).then((res) => {
        this.info = res.data.teacher
        this.represe = res.data.book;
      })
      this.page.page = 1;
      this.page.load();
    },
    addCollect(val) {
      if (this.$com.openLogin()) {
        return;
      }
      this.$bti.SubmitCollect({ sourceId: val.ID, sourceType: 1 }).then((res) => {
        if (res.code != 1) {
          return;
        }
        this.$message({ type: "success", message: "成功" });
        val.IsCollect = !val.IsCollect;
      });
    },
    addCollect1(val) {
      if (this.$com.openLogin()) {
        return;
      }
      this.$bti.SubmitCollect({ sourceId: val.id, sourceType: 1 }).then((res) => {
        if (res.code != 1) {
          return;
        }
        this.$message({ type: "success", message: "成功" });
        val.isCollect = !val.isCollect;
      });
    },
  },
}
</script>

<style lang="css" scoped>
.author-page,
.author-bottom,
.info-sec .sec-con {
  display: -webkit-box;
  display: -ms-flexbox;
  display: -webkit-flex;
  display: flex;
  flex-wrap: nowrap;
  -webkit-box-pack: justify;
  -ms-flex-pack: justify;
  -webkit-justify-content: space-between;
  justify-content: space-between;
}

.author-page {
  -webkit-box-align: start;
  -ms-flex-align: start;
  -webkit-align-items: flex-start;
  align-items: flex-start;
}

.author-page .left,
.author-bottom .info-left {
  background-color: #fff;
  border-radius: 10px;
  margin-bottom: 25px;
}

.author-page .left {
  width: 137px;
}

.author-page .right {
  width: calc(100% - 157px);
}

.author-box {
  position: relative;
  background-color: #fff;
  border-radius: 10px;
  padding: 20px 10px;
  margin-bottom: 20px;
}

.author-list {
  margin: 0 40px;
}

.swiper-button-prev,
.swiper-button-next {
  background-image: none;
}

.swiper-button-prev .el-icon-arrow-left,
.swiper-button-next .el-icon-arrow-right {
  font-size: 28px;
  color: #272636;
  font-weight: bold;
}

.author-list .item {
  opacity: 0.5;
  cursor: pointer;
}

.author-list .item a {
  width: 70px;
  display: block;
  color: #333;
  margin: 0 auto;
}

.author-list .item.is-current {
  opacity: 1;
}

.author-list .item.is-current a {
  color: #3C9B9E;
  font-weight: bold;
}

.author-list .item .s-img {
  width: 70px;
  height: 70px;
  border-radius: 100%;
  overflow: hidden;
  margin: 0 auto;
}

.author-list .item .s-img img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.author-list .item .info {
  text-align: center;
  font-size: 12px;
}

.author-list .item .info .time,
.author-list .item .info .author {
  margin-top: 7px;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
}

.author-list .item .info .time {
  border-bottom: 1px solid #ccc;
  padding-bottom: 6px;
}

.author-bottom .info-left {
  width: 611px;
  padding: 20px 15px;
}

.author-bottom .info-right {
  width: calc(100% - 631px);
  margin-bottom: 25px;
}

.author-bottom .info-left .info-head {
  margin-bottom: 25px;
  position: relative;
  padding-left: 20px;
}

.author-bottom .info-left .info-head .title {
  font-weight: bold;
  color: #3C9B9E;
}

.author-bottom .info-left .info-head .des {
  margin-top: 10px;
  line-height: 1.6;
  font-size: 12px;
}

.author-bottom .info-left .info-head:before {
  position: absolute;
  left: 0;
  top: 0;
  display: block;
  content: '';
  width: 7px;
  height: 38px;
  background-color: #3C9B9E;
  border-radius: 7px;
}

.info-sec {
  margin: 0 20px 20px 20px;
}

.info-sec .sec-ti {
  width: 90px;
  height: 25px;
  line-height: 25px;
  color: #fff;
  background: linear-gradient(270deg, rgba(60, 155, 158, 0) 0%, #3C9B9E 100%);
  padding-left: 10px;
}

.info-sec .sec-con {
  margin: 15px 0;
}

.info-sec .sec-con .sec-img {
  width: 127px;
  height: 139px;
  overflow: hidden;
}

.info-sec .sec-con .sec-img img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.info-sec .sec-con .sec-content {
  width: calc(100% - 127px - 20px);
  height: 154px;
  line-height: 1.6;
  font-size: 12px;
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
}

/* 对于Webkit内核浏览器 */
.info-sec .sec-con .sec-content::-webkit-scrollbar {
  width: 8px;
}

.info-sec .sec-con .sec-content::-webkit-scrollbar-thumb {
  background-color: #999;
  border-radius: 6px;
}

.info-sec .sec-con .sec-content::-webkit-scrollbar-track {
  background-color: transparent;
  border-radius: 6px;
}

/* 对于Firefox */
.info-sec .sec-con .sec-content {
  scrollbar-width: thin;
  scrollbar-color: #999 transparent;
}

.bd-item,
.s-para,
.s-btns {
  display: -webkit-box;
  display: -ms-flexbox;
  display: -webkit-flex;
  display: flex;
  flex-wrap: nowrap;
}

.bd-item {
  -webkit-box-pack: start;
  -ms-flex-pack: start;
  -webkit-justify-content: flex-start;
  justify-content: flex-start;
  cursor: pointer;
}

.bd-item .s-img {
  width: 100px;
  height: 130px;
  position: relative;
}

.bd-item .s-img img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  box-shadow: 0px 3px 6px 0px rgba(0, 0, 0, 0.251);
  -webkit-box-shadow: 0px 3px 6px 0px rgba(0, 0, 0, 0.251);
  -moz-box-shadow: 0px 3px 6px 0px rgba(0, 0, 0, 0.251);
  -o-box-shadow: 0px 3px 6px 0px rgba(0, 0, 0, 0.251)
}

.ou-lf-tag {
  border-top-right-radius: 0px;
}

.bd-item .s-info {
  margin-left: 20px;
  width: calc(100% - 120px);
  position: relative;
}

.bd-item .s-btns {
  position: absolute;
  right: 0;
  top: 0;
}

.bd-item .s-ti,
.bd-item .s-para,
.bd-item .s-rate {
  margin-bottom: 10px;
}

.bd-item .s-ti {
  font-family: HarmonyOS Sans SC;
  color: #272636;
  width: 440px;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
  margin-bottom: 20px;
}

.bd-item .s-para {
  color: #B8B8B8;
}

.bd-item .s-dec {
  color: #B8B8B8;
  font-size: 12px;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
  width: 100%;
  line-height: 1.4;
}

.bd-item .item-btn {
  padding: 3px 15px 4px 15px;
  border-radius: 30px;
  color: #fff;
  margin-left: 15px;
  cursor: pointer;
}

.bd-item .item-btn .icon {
  padding-right: 5px;
  position: relative;
  top: 1px;
}

.bd-item .para-item span {
  padding: 0 5px;
}

.hot-box {
  position: relative;
  background: -webkit-gradient(linear, left top, left bottom, from(#FFF9EB), color-stop(47%, #FFFFFF));
  background: linear-gradient(180deg, #FFF9EB 0%, #FFFFFF 47%);
  background: -ms-linear-gradient(180deg, #FFF9EB 0%, #FFFFFF 47%);
  background: -moz-linear-gradient(180deg, #FFF9EB 0%, #FFFFFF 47%);
  background: -o-linear-gradient(180deg, #FFF9EB 0%, #FFFFFF 47%);
  border-radius: 10px;
  padding: 20px 30px;
  margin-bottom: 25px;
  height: 100%;
}

.hot-box .ri-arrow {
  position: absolute;
  right: 0;
  top: 0;
  z-index: 5;
  content: '';
  width: 0;
  height: 0;
  border: 25px solid;
  border-color: #F3F5F7 #F3F5F7 #ffffff #ffffff;
  box-shadow: -3px 3px 3px 0px rgba(0, 0, 0, 0.1608);
  -webkit-box-shadow: -3px 3px 3px 0px rgba(0, 0, 0, 0.1608);
  -moz-box-shadow: -3px 3px 3px 0px rgba(0, 0, 0, 0.1608);
  -o-box-shadow: -3px 3px 3px 0px rgba(0, 0, 0, 0.1608);
  border-bottom-left-radius: 10px;
}

.h-head {
  font-weight: bold;
  margin-bottom: 40px;
}

.h-body {
  display: -webkit-box;
  display: -ms-flexbox;
  display: -webkit-flex;
  display: flex;
  flex-wrap: wrap;
  -webkit-box-pack: start;
  -ms-flex-pack: start;
  -webkit-justify-content: flex-start;
  justify-content: flex-start;
  width: calc(100% + 40px);
  margin-left: -20px;
  /*width: 100%;*/
  /*margin-top: 20px;*/
  /*margin-bottom: 20px;*/
}

.h-body .h-item {
  width: 90px;
  margin: 13px 20px;
  cursor: pointer;
}

.h-body .h-item a {
  width: 90px;
  display: block;
}

.hot-box .s-img {
  width: 90px;
  height: 125px;
  position: relative;
}

.hot-box .s-img img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  box-shadow: 0px 3px 6px 0px rgba(0, 0, 0, 0.251);
  -webkit-box-shadow: 0px 3px 6px 0px rgba(0, 0, 0, 0.251);
  -moz-box-shadow: 0px 3px 6px 0px rgba(0, 0, 0, 0.251);
  -o-box-shadow: 0px 3px 6px 0px rgba(0, 0, 0, 0.251);
}

.hot-box .s-ti {
  margin-top: 17px;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
  color: #272636;
  font-size: 12px;
  text-align: center;
}

.swiperBtns {
  position: relative;
  height: 30px;
  padding: 30px 0 20px 0;
  display: -webkit-box;
  display: -ms-flexbox;
  display: -webkit-flex;
  display: flex;
  flex-wrap: nowrap;
  -webkit-box-pack: center;
  -ms-flex-pack: center;
  -webkit-justify-content: center;
  justify-content: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  -webkit-align-items: center;
  align-items: center;
}

.rightPrev,
.rightNext {
  position: inherit;
  left: inherit;
  right: inherit;
  top: 0;
  width: 30px;
  height: 30px;
  line-height: 30px;
  background-color: #F3F5F7;
  border-radius: 5px;
  margin: 0 7px;
  text-align: center;
}

.rightPrev i,
.rightNext i {
  font-size: 16px !important;
}

.ou-pagination {
  position: absolute;
  bottom: 20px;
  right: 0px;
  width: 100%;
}

/*图书纬度展示效果*/
.author-sec {
  border-radius: 10px;
  background-color: #fff;
  padding: 20px;
  margin-bottom: 25px;
}

.huojiang-title {
  padding: 10px 0;
  text-align: center;
  color: #3C9B9E;
  font-weight: bold;
  font-size: 16px;
}

.huojiang-title img {
  padding-right: 10px;
}

.authorjx-info {
  width: 957px;
  margin-left: 22.7px;
  background-color: #F3F5F7;
  padding: 15px;
  border-radius: 6px;
  line-height: 1.6;
  margin-bottom: 20px;
}

.author-sec .list-box {
  display: -webkit-box;
  display: -ms-flexbox;
  display: -webkit-flex;
  display: flex;
  flex-wrap: wrap;
  -webkit-box-pack: start;
  -ms-flex-pack: start;
  -webkit-justify-content: flex-start;
  justify-content: flex-start;
  width: calc(100% + 45.4px);
  margin-left: -22.7px;
}

.author-sec .list-box .item {
  width: 170px;
  margin: 15px 45.7px;
}

.author-sec .list-box .item .s-img {
  width: 100%;
  height: 225px;
  overflow: hidden;
  border-radius: 8px;
}

.author-sec .list-box .item .s-img img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.author-sec .list-box .item .s-info {
  text-align: center;
  margin-top: 10px;
}

.author-sec .list-box .item .s-info .name {
  font-weight: bold;
  margin-bottom: 5px;
}

.author-sec .list-box .item .s-info .para {
  color: #B8B8B8;
  font-size: 12px;
}

.author-sec .list-box .item .s-info .name,
.author-sec .list-box .item .s-info .para {
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
}

.author-sec .list-box .item .s-info .para {
  margin-top: 7px;
}

.author-sec .list-box .item .s-btns {
  margin-top: 12px;
  display: -webkit-box;
  display: -ms-flexbox;
  display: -webkit-flex;
  display: flex;
  flex-wrap: nowrap;
  -webkit-box-pack: justify;
  -ms-flex-pack: justify;
  -webkit-justify-content: space-between;
  justify-content: space-between;
  -webkit-box-align: center;
  -ms-flex-align: center;
  -webkit-align-items: center;
  align-items: center;
}

.author-sec .list-box .item .s-btns .item-btn {
  padding: 0px 10px;
  border-radius: 30px;
  color: #fff;
  cursor: pointer;
  height: 24px;
  line-height: 24px;
}

.bl-title {
  color: #3C9B9E;
  position: relative;
  padding-left: 18px;
  font-weight: bold;
  line-height: 1.4;
}

.bl-title:before {
  position: absolute;
  left: 0;
  top: 0;
  content: '';
  width: 6px;
  height: 18px;
  background-color: #3C9B9E;
  border-radius: 8px;
}

.ti-tab-list {
  position: relative;
  margin-top: 15px;
  margin-bottom: 20px;
  padding: 0 30px;
}

.yearPrev {
  left: 0;
}

.yearNext {
  right: 0;
}

.yearPrev,
.yearNext {
  margin-top: 0;
  top: 3px;
}

.yearPrev .el-icon-arrow-left,
.yearNext .el-icon-arrow-right {
  font-size: 24px;
}

.year-list .item {
  height: 30px;
  line-height: 30px;
  background-color: #F3F5F7;
  padding: 0 5px;
  text-align: center;
  border-radius: 6px;
  color: #272636;
  cursor: pointer;
}

.year-list .item.is-current {
  background-color: #3C9B9E;
  color: #fff;
}

.year-list .item .item-inner,
.year-list .item .item-inner span {
  text-align: center;
}

.year-list .item .item-inner span {
  display: block;
}

/*.year-list .item .item-inner span:nth-child(1){*/
/*  padding-right: 5px;*/
/*}*/
/*.year-list .item .item-inner span:nth-child(2){*/
/*  padding-left: 5px;*/
/*}*/</style>



// WEBPACK FOOTER //
// src/pages/categry/Author.vue